import React from 'react';

export const Tabs = ({ tabs, selectedTab, handleChangeTab }) => {
  return (
    <div
      style={{
        display: 'flex',
        width: 'fit-content',
        border: '1px solid black',
        cursor: 'pointer',
      }}
    >
      {tabs.map((tab, i) => (
        <div
          key={i}
          onClick={() => handleChangeTab(tab)}
          style={{
            padding: '8px 10px',
            borderRight: i !== tabs.length - 1 ? '1px solid black' : 'none',
            backgroundColor: tab === selectedTab ? 'lightgray' : 'white',
          }}
        >
          <p style={{ fontWeight: 'bold' }}>{tab}</p>
        </div>
      ))}
    </div>
  );
};
